const isPlainObject = (value) => value && typeof value === "object" && !Array.isArray(value);

const mergeSections = (target, sectionContainer) => {
    if (!isPlainObject(sectionContainer)) return;

    Object.entries(sectionContainer).forEach(([sectionKey, sectionFields]) => {
        if (!isPlainObject(sectionFields)) return;
        target[sectionKey] = {
            ...(target[sectionKey] || {}),
            ...sectionFields
        };
    });
};

export const normalizeFicha = (rawFicha) => {
    if (!isPlainObject(rawFicha)) return {};

    const normalized = {};

    Object.entries(rawFicha).forEach(([key, value]) => {
        if (key === "fichas_base" || key === "ficha_base" || key === "ficha_extra") return;
        if (isPlainObject(value)) {
            mergeSections(normalized, { [key]: value });
        }
    });

    const baseFichas = rawFicha.fichas_base ?? rawFicha.ficha_base;
    if (Array.isArray(baseFichas)) {
        baseFichas.forEach((item) => mergeSections(normalized, item));
    } else if (isPlainObject(baseFichas)) {
        Object.values(baseFichas).forEach((item) => mergeSections(normalized, item));
    }

    const fichaExtra = rawFicha.ficha_extra;
    if (isPlainObject(fichaExtra)) {
        const extraBaseFichas = fichaExtra.fichas_base ?? fichaExtra.ficha_base;

        if (Array.isArray(extraBaseFichas)) {
            extraBaseFichas.forEach((item) => mergeSections(normalized, item));
        } else if (isPlainObject(extraBaseFichas)) {
            Object.values(extraBaseFichas).forEach((item) => mergeSections(normalized, item));
        }

        Object.entries(fichaExtra).forEach(([key, value]) => {
            if (key === "fichas_base" || key === "ficha_base") return;
            if (isPlainObject(value)) {
                mergeSections(normalized, { [key]: value });
            }
        });
    }

    return normalized;
};